export default "__VITE_ASSET__2c9c3252__"